import "./css/main.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import MyRide from "./pages/my_rides";
import DashboardPage from "./pages/DashboardPage";
import LoginPage from "./pages/LoginPage";
import OtpLogin from "./pages/OtpLogin";
import SignupPage from "./pages/SignupPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import HomePage from "./pages/HomePage";
import ViewRides from "./pages/view_ride_page";
import SearchRide from "./pages/search_ride_page";
import RideForm from "./pages/ride_form";
import ProfilePage from "./pages/ProfilePage";
import {
  ProtectedRoute,
  getToken,
  verifyToken,
  configureStatusBar,
} from "@ridecloud/shared";
import { useEffect, useState } from "react";
import { SplashScreen } from "@capacitor/splash-screen";

const AppRoutes = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    SplashScreen.hide();
    configureStatusBar(location.pathname);
    const checkLogin = async () => {
      const token = await getToken();
      const user_data = await verifyToken(token);
      setIsAuthenticated(user_data.valid);

      setLoading(false);
    };

    checkLogin();
  }, [location.pathname]);

  if (loading) {
    return null;
  } else {
    return (
      <Routes>
        {/* Use `element` prop to render components */}
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <HomePage />
            )
          }
        />
        <Route
          path="*"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <HomePage />
            )
          }
        />
        <Route
          path="/login"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/otp-login"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <OtpLogin />
            )
          }
        />
        <Route
          path="/signup"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <SignupPage />
            )
          }
        />
        <Route
          path="/forgot-password"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <ForgotPasswordPage />
            )
          }
        />
        {/* Protected Routes */}
        <Route element={<ProtectedRoute allowedRoles={["user"]} />}>
          <Route
            path="/dashboard"
            element={
              <DashboardPage onLogout={() => setIsAuthenticated(false)} />
            }
          />
          <Route path="/my-rides" element={<MyRide />} />
          <Route path="/view-rides" element={<ViewRides />} />
          <Route path="/search-rides" element={<SearchRide />} />
          <Route path="/post-ride" element={<RideForm mode="create" />} />
          <Route
            path="/update-ride/:rideId"
            element={<RideForm mode="edit" />}
          />
          <Route path="/profile" element={<ProfilePage />} />
        </Route>
      </Routes>
    );
  }
};
const App = () => {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
};
export default App;
